// @ts-nocheck
// TODO: tighten types after migration
import React, { useState, useEffect } from 'react';
import './Subscribe.css';
import { API_ENDPOINTS } from '../config/api';
import { getAuthUser, getMonthlyReadArticles, FREE_ARTICLES_LIMIT, setNewsletterSubscribed, isNewsletterSubscribed } from '../utils/auth';

export default function Subscribe({ title, subtitle, onSubscribed, showMonthlyLimitBadge = true, className = "" }) {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [loading, setLoading] = useState(false);
    const [readCount, setReadCount] = useState(() => getMonthlyReadArticles().length);
    const [isLoggedIn, setIsLoggedIn] = useState(() => !!getAuthUser());
    const [alreadySubscribed, setAlreadySubscribed] = useState(() => isNewsletterSubscribed());

    useEffect(() => {
        const updateState = () => {
            setReadCount(getMonthlyReadArticles().length);
            setIsLoggedIn(!!getAuthUser());
            setAlreadySubscribed(isNewsletterSubscribed());
        };

        window.addEventListener('monthlyReadArticlesUpdated', updateState);
        window.addEventListener('userUpdated', updateState);
        window.addEventListener('newsletterSubscriptionUpdated', updateState);

        return () => {
            window.removeEventListener('monthlyReadArticlesUpdated', updateState);
            window.removeEventListener('userUpdated', updateState);
            window.removeEventListener('newsletterSubscriptionUpdated', updateState);
        };
    }, []);

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        // Validate email
        if (!email.trim()) {
            setError('Please enter your email address');
            return;
        }

        if (!validateEmail(email)) {
            setError('Please enter a valid email address');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(API_ENDPOINTS.NEWSLETTER.SUBSCRIBE, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email: email.trim() }),
            });

            const data = await response.json();

            if (response.ok || (data && (data.success || response.status === 200 || response.status === 201))) {
                setSuccess(data.message || 'Successfully subscribed! You can now read unlimited free articles.');
                setNewsletterSubscribed(true);
                setAlreadySubscribed(true);
                setEmail('');
                if (onSubscribed) {
                    onSubscribed(email.trim());
                }
                setTimeout(() => {
                    setSuccess('');
                }, 6000);
            } else if (data.message && data.message.toLowerCase().includes('already subscribed')) {
                setSuccess('You are already subscribed! Enjoy unlimited reading.');
                setNewsletterSubscribed(true);
                setAlreadySubscribed(true);
                setEmail('');
                if (onSubscribed) {
                    onSubscribed(email.trim());
                }
                setTimeout(() => {
                    setSuccess('');
                }, 6000);
            } else {
                setError(data.message || 'Failed to subscribe. Please try again.');
            }
        } catch (err) {
            console.error('Error subscribing to newsletter:', err);
            setError('Network error. Please check your connection and try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (error) {
            setError('');
        }
        if (success) {
            setSuccess('');
        }
    };

    const isLimitReached = !isLoggedIn && readCount >= FREE_ARTICLES_LIMIT;

    return (
        <div className={`subscribe-container w-full rounded-3xl bg-white/90 p-4 shadow-sm backdrop-blur-sm ${className}`}>
            {showMonthlyLimitBadge && !isLoggedIn && !alreadySubscribed && (
                <div className={`subscribe-limit-badge ${isLimitReached ? 'limit-reached' : ''}`}>
                    <span className="badge-icon">📖</span>
                    <span className="badge-text">
                        {isLimitReached ? (
                            <>You have read all <strong>{FREE_ARTICLES_LIMIT} free articles</strong> for this month</>
                        ) : (
                            <>You have read <strong>{readCount} of {FREE_ARTICLES_LIMIT} free articles</strong> this month</>
                        )}
                    </span>
                </div>
            )}
            <h3 className="subscribe-text text-base font-semibold text-slate-900">
                {title || (isLimitReached 
                    ? "Subscribe to Newsletter to continue reading unlimited free articles!" 
                    : "Want to receive updates? Subscribe now!")}
            </h3>
            {subtitle && <p className="subscribe-subtitle text-xs text-slate-600 mb-2">{subtitle}</p>}
            <form className="subscribe-form mt-3" onSubmit={handleSubmit}>
                <div className={`subscribe-input-wrapper ${error ? 'subscribe-input-error' : ''} ${success ? 'subscribe-input-success' : ''} relative flex items-center overflow-hidden rounded-full bg-slate-100`}>
                    <input
                        type="email"
                        className="subscribe-input w-full bg-transparent text-sm text-slate-800"
                        placeholder="Your email"
                        value={email}
                        onChange={handleEmailChange}
                        disabled={loading}
                    />
                    <button
                        type="submit"
                        className={`subscribe-button ${loading ? 'subscribe-button-loading' : ''} inline-flex h-10 w-10 items-center justify-center rounded-full`}
                        disabled={loading || !email.trim()}
                        aria-label={loading ? 'Subscribing...' : 'Subscribe'}
                    >
                        {loading ? (
                            <span className="subscribe-spinner"></span>
                        ) : (
                            <i className="fi fi-bs-paper-plane"></i>
                        )}
                    </button>
                </div>
                {error && (
                    <div className="subscribe-message subscribe-error">
                        {error}
                    </div>
                )}
                {success && (
                    <div className="subscribe-message subscribe-success">
                        {success}
                    </div>
                )}
            </form>
        </div>
    );
}


